import React, { useEffect, useState } from 'react';
import Icon from '../../../../components/AppIcon';

const EmailValidator = ({ email, onValidationChange }) => {
    const [validation, setValidation] = useState({ isValid: false, message: '', isChecking: false });

    useEffect(() => {
        if (!email) {
            setValidation({ isValid: false, message: '', isChecking: false });
            onValidationChange({ isValid: false, message: '' });
            return;
        }

        const validateEmail = async () => {
            setValidation(prev => ({ ...prev, isChecking: true }));

            // Basic email format validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(email)) {
                const result = { isValid: false, message: 'Please enter a valid email address' };
                setValidation({ ...result, isChecking: false });
                onValidationChange(result);
                return;
            }

            // Check for common typos in domain
            const commonDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com'];
            const domain = email.split('@')[1]?.toLowerCase();

            // Simulate API call delay
            await new Promise(resolve => setTimeout(resolve, 800));

            // Check for suspicious domains or disposable emails
            const disposableDomains = ['10minutemail.com', 'tempmail.org', 'guerrillamail.com'];

            if (disposableDomains.includes(domain)) {
                const result = { isValid: false, message: 'Disposable email addresses are not allowed' };
                setValidation({ ...result, isChecking: false });
                onValidationChange(result);
                return;
            }

            // Valid email
            const result = { isValid: true, message: 'Email looks good!' };
            setValidation({ ...result, isChecking: false });
            onValidationChange(result);
        };

        const timeoutId = setTimeout(validateEmail, 500);
        return () => clearTimeout(timeoutId);
    }, [email, onValidationChange]);

    if (!email) return null;

    return (
        <div className="mt-2">
            {validation.isChecking ? (
                <div className="flex items-center text-sm text-accent-600">
                    <Icon name="loader" className="w-4 h-4 mr-2 animate-spin" />
                    Checking email...
                </div>
            ) : validation.message ? (
                <div className={`flex items-center text-sm ${validation.isValid ? 'text-green-600' : 'text-red-600'
                    }`}>
                    <Icon
                        name={validation.isValid ? 'check-circle' : 'x-circle'}
                        className="w-4 h-4 mr-2"
                    />
                    {validation.message}
                </div>
            ) : null}
        </div>
    );
};

export default EmailValidator; 